import * as React from "react";
import { isClientLocalhost } from "@/lib/env-check";

export function useIsLocalhost(): boolean {
  const [isLocalhost, setIsLocalhost] = React.useState<boolean>(() => {
    return process.env.NODE_ENV === "development";
  });

  React.useEffect(() => {
    setIsLocalhost(isClientLocalhost());
  }, []);

  return isLocalhost;
}
